/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3 } from 'three';
import { BasePanNavigator } from './BasePanNavigator';
import { NavUtils } from './NavUtils';
const INTERNAL_SPEED_FACTOR = 0.01;
/**
 * Navigator for rotating the scene around the custom scene-up vector while the user is panning
 * The scene-up vector is read from the camera's `.userData.sceneUp`
 */
export class RotateAroundNavigator extends BasePanNavigator {
    constructor(cam, el, speed = 1) {
        super(cam, el, speed);
        this.allowPanDuringPinch = false;
        this.up = new Vector3(0, 1, 0);
        this._calcLookAt = NavUtils.calcLookAt(() => this._cam);
        this._calcCameraRight = NavUtils.calcCameraRight(() => this._cam);
    }
    pan(event) {
        const { movementX, movementY } = event.detail;
        const speed = this.speed * INTERNAL_SPEED_FACTOR;
        const angleUp = -movementX * speed;
        const angleRight = movementY * speed;
        const camera = this._cam;
        const rotation = NavUtils.rotateCameraAround(camera.position, this._calcLookAt(), this._calcCameraRight(), this.up, angleUp, angleRight, NavUtils.getPivot(camera));
        camera.matrix.copy(rotation.matrix);
        camera.quaternion.setFromRotationMatrix(rotation.matrix);
        camera.position.copy(rotation.position);
        camera.up.copy(rotation.up);
    }
}
//# sourceMappingURL=RotateAroundNavigator.js.map